import TKCustomElementFactory from '@tk/utilities/tk.custom.element.factory';
import { fromBase64 } from '@tk/utilities/tk.base64';

interface BlogPost {
    id: string;
    title: string;
    text: string;
    author: string;
    date: string;
}

export default class TKBlog extends TKCustomElementFactory {
    src = this.getAttribute('data-tk-src') || '';
    category = this.getAttribute('data-tk-category') || '';
    form = document.getElementById(this.getAttribute('data-tk-form') || '') as HTMLFormElement | null;
    post?: BlogPost;

    connectedCallback() {
        const editButton = this.querySelector('[data-tk-blog-edit]');
        if (editButton) this.pushListener({ event: 'click', element: editButton, action: this.edit.bind(this) });
        this.load();
    }

    async load() {
        const response = await fetch(this.src, { cache: 'no-store' });
        this.post = await response.json();

        this.querySelector('[data-tk-blog-title]')!.textContent = fromBase64(this.post!.title);
        this.querySelector('[data-tk-blog-text]')!.textContent = fromBase64(this.post!.text);
        this.querySelector('[data-tk-blog-author]')!.textContent = fromBase64(this.post!.author);
        this.querySelector('[data-tk-blog-date]')!.textContent = this.post!.date;
    }

    edit() {
        if (!this.form || !this.post) return;

        this.setField('id', this.post.id);
        this.setField('title', fromBase64(this.post.title));
        this.setField('text', fromBase64(this.post.text));
        this.setField('category', this.category);
        this.setField('originalCategory', this.category);
        this.form.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    setField(name: string, value: string) {
        const field = this.form!.elements.namedItem(name) as HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement;
        field.value = value;
        field.dispatchEvent(new Event('input', { bubbles: true }));
    }
}
